import http from 'plugins/axios'

export default {
  //之前的获取用户列表
  // getUserList({
  //   page = 1,
  //   size = 25,
  //   queryType,
  //   queryValue,
  //   userStatus,
  //   userType,
  //   mark
  // }) {
  //   return http.get({
  //     url: `/ta/admin/trade/user/${page}/${size}`,
  //     data: {
  //       queryType,
  //       queryValue,
  //       userStatus,
  //       userType,
  //       mark
  //     }
  //   });
  // },
  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: `/ta/admin/rebate/getRiskList`,
      data,
    })
  },

  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate, spotRate }) {
    const params = [
      `channelId=${channelId}`,
      `userId=${userId}`,
      `rate=${rate}`,
    ]
    if (spotRate !== undefined && spotRate !== '' && spotRate !== null) {
      params.push(`spotRate=${spotRate}`)
    }
    return http.post({
      url: `/channel/partner/rebateRate?${params.join('&')}`,
    })
  },

  //可交易开关
  allowTrade({ userId, type }) {
    return http.post({
      url: `/ta/admin/user/allowTrade?userId=${userId}&type=${type}`,
    })
  },
  //可划入开关
  allowTransfer({ userId, type }) {
    return http.post({
      url: `/ta/admin/user/allowTransfer?userId=${userId}&type=${type}`,
    })
  },
  //开关仓开关
  allowSwitchBin({ userId, type }) {
    return http.post({
      url: `/ta/admin/user/open-position-switch?userId=${userId}&type=${type}`,
    })
  },
  updateVolunteer({ id, status }) {
    return http.post({
      url: `/ta/admin/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status,
      },
      dataType: 'form',
    })
  },
  updateBlocking({ id, status, content }) {
    return http.post({
      url: '/ta/admin/trade/user/updateUserStatus',
      data: {
        id,
        userStatus: status,
        content: content,
      },
      dataType: 'form',
    })
  },
  cancelGoogle(data) {
    return http.post({
      url: '/ta/admin/user/delete/googleAuth',
      data,
      dataType: 'form',
    })
  },
  coutryCode() {
    return http.get({
      url: '/ta/admin/tenant/countryCodeList',
    })
  },
  updatInfo(data) {
    return http.post({
      url: '/ta/admin/user/update/tel',
      data,
      dataType: 'form',
    })
  },
  updateUserType(data) {
    return http.post({
      url: '/ta/admin/user/userType/update',
      data,
      dataType: 'form',
    })
  },
  updateDividendStatus(data) {
    return http.post({
      url: '/ta/admin/user/dividend/status/update',
      data,
      dataType: 'form',
    })
  },
  setNode(data) {
    return http.post({
      url: '/ta/admin/starplan/create/node',
      data,
      dataType: 'form',
    })
  },
  resetPassword(data) {
    return http.post({
      url: '/ta/admin/user/password/reset',
      data,
      dataType: 'form',
    })
  },
  updateMark(data) {
    return http.post({
      url: '/ta/admin/user/mark',
      data,
      dataType: 'form',
    })
  },

  getExcelData(data) {
    return http.get({
      url: '/ta/admin/rebate/listExport',
      data,
      responseType: 'blob',
    })
  },

  getTotalAmount(data) {
    return http.get({
      url: '/ta/admin/rebate/getTotalAmount',
      data,
    })
  },
  getExcelData(data) {
    return http.get({
      url: '/ta/admin/rebate/getRiskList/excel',
      data,
      responseType: 'blob',
    })
  },
}
